var map = {
	"./luis_guedes.jpg": 58,
	"./luis_guedes_mobile.jpg": 59,
	"./maria_pinto.jpg": 60,
	"./mario_dantas.jpg": 61,
	"./mario_dantas_mobile.jpeg": 62,
	"./nuno_lucia.jpg": 63,
	"./readme.md": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;